import { useConnectionStatus } from "../../lib/connection/connection-context";
import { StatusBanner } from "./StatusBanner";

/**
 * The single persistent banner for offline, stale or unconfirmed data.
 *
 * `AGENTS.md` reserves persistent banners for "offline/sync/backup
 * degradation", so this one has no dismiss control: the condition is still true
 * after you close it. Routine successes use a toast instead, and validation
 * uses inline messages.
 *
 * It shows only when BurgePOS failed to answer, or confirmed data has aged;
 * nothing is shown before any data screen has asked.
 */
export function ConnectionStatusBanner({ className }: { className?: string }) {
  const { notice } = useConnectionStatus();

  if (notice.tone === null) {
    return null;
  }

  return (
    <StatusBanner
      className={className}
      description={notice.description}
      title={notice.title}
      tone={notice.tone}
    />
  );
}
